<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="category_uuid">
                <PlanCategory :lang="form.lang" v-model="form.category_uuid" style="width: 300px"></PlanCategory>
            </el-form-item>
            <el-form-item label="方案名称" prop="name">
                <el-input maxlength="40" v-model="form.name" placeholder="请输入方案名称" style="width: 600px"></el-input>
            </el-form-item>
            <el-form-item label="封面图" prop="cover">
                <Uploader v-model="form.cover"></Uploader>
            </el-form-item>
            <el-form-item label="功能介绍" prop="info">
				<el-input :rows="10" type="textarea" v-model="form.info" placeholder="请输入功能介绍"></el-input>
                <!-- <Editor v-model="form.info"></Editor> -->
            </el-form-item>
            <el-form-item label="添加案例" prop="mcase">
                <el-button type="text" @click="handleAddCase">添加案例</el-button>
                <el-table :data="cases">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="案例标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="category.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="handleCaseDel(row)">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="添加产品" prop="goods">
                <el-button type="text" @click="handleAddGoods">添加商品</el-button>
                <el-table :data="goods">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="商品标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="category.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="handleGoodsDel(row)">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="上传文件" prop="file">
                <el-button type="text" @click="handleAddFile">上传文件</el-button>
                <el-table :data="files">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="文件标题" prop="name"></el-table-column>
                    <el-table-column label="分类" prop="mgroup.name"></el-table-column>
                    <el-table-column label="创建时间" prop="create_time"></el-table-column>
                    <el-table-column label="下载人群" prop="type">
                        <template slot-scope="{ row }">
                            {{ { 1: "注册用户", 2: "特殊标签用户" }[row.type] }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="handleFileDel(row)">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="适用场景" prop="type">
                <el-radio-group v-model="form.type">
                    <el-radio label="1">富文本</el-radio>
                    <el-radio label="2">视频</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.type == 1" label="" prop="detail">
                <Editor v-model="form.detail"></Editor>
            </el-form-item>
            <el-form-item v-if="form.type == 2" label="" prop="video_uuid">
                <el-button @click="handleVideoPick">请选择</el-button>
                <el-tag v-if="videoData.uuid" style="margin-left: 10px" closable @close="handleVideoClose">{{ videoData.name }}</el-tag>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
                <el-button style="width: 120px" type="primary" @click="handleConfirm">发布</el-button>
            </el-form-item>
        </el-form>
        <CasePicker ref="case" @pick="pickCase" v-model="cases" :lang="form.lang"></CasePicker>
        <GoodsMultiplePicker ref="goods" @pick="pickGoods" v-model="goods"></GoodsMultiplePicker>
        <FilePicker ref="file" @pick="pickFile" :lang="form.lang"></FilePicker>
        <VideoPicker ref="video" @pick="pickVideo"></VideoPicker>
    </div>
</template>

<script>
import Language from "@/components/Language";
import PlanCategory from "@/components/PlanCategory";
import CasePicker from "@/components/CasePicker";
import GoodsMultiplePicker from "@/components/GoodsMultiplePicker";
import FilePicker from "@/components/FilePicker";
import VideoPicker from "@/components/VideoPicker";
import Uploader from "@/components/Uploader";
import Editor from "@/components/Editor";
import { add, edit, detail } from "@/api/plan/list";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Language, PlanCategory, CasePicker, GoodsMultiplePicker, FilePicker, Uploader, Editor, VideoPicker },
    data() {
        return {
            form: {
                lang: "zh",
                sort: "",
                category_uuid: "",
                name: "",
                cover: "",
                info: "",
                mcase: [],
                goods: [],
                file: [],
                type: "1",
            },
            rules: {
                sort: [{ required: true, message: "请输入排序" }],
                category_uuid: [{ required: true, message: "请选择分类" }],
                name: [{ required: true, message: "请输入标题" }],
            },
            cases: [],
            goods: [],
            files: [],
            isEdit: false,
            cuuid: "",
            videoData: {},
            add: true,
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        if (this.form.cuuid) {
            this.add = false;
            this.isEdit = true;
            this.getDetail();
        } else {
            this.add = true;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.cuuid = result.cuuid;
                        this.keyword = this.form.keyword;
                        this.cases = result.mcase;
                        this.goods = result.goods;
                        this.files = result.file.map((x) => ({ ...x, type: x.pivot.type }));
                        this.videoData = {
                            uuid: result.video.uuid,
                            name: result.video.name,
                        };
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid };
                        this.cuuid = "";
                        this.cases = [];
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleAddCase() {
            this.$refs.case.open();
        },
        handleAddGoods() {
            this.$refs.goods.open();
        },
        handleAddFile() {
            this.$refs.file.open();
        },
        pickCase(data) {
            this.cases = data;
        },
        pickGoods(data) {
            this.goods = data;
        },
        pickFile(data) {
            data.forEach((x) => {
                if (this.files.find((n) => n.uuid === x.uuid)) {
                    this.files = this.files.filter((m) => m.uuid !== x.uuid);
                    this.files.push(x);
                } else {
                    this.files.push(x);
                }
            });
        },
        handleCaseDel(row) {
            this.cases = this.cases.filter((item) => item !== row);
        },
        handleGoodsDel(row) {
            this.goods = this.goods.filter((item) => item !== row);
        },
        handleFileDel(row) {
            this.files = this.files.filter((item) => item !== row);
        },
        handleVideoPick() {
            this.$refs.video.open();
        },
        pickVideo(data) {
            this.videoData = data;
        },
        handleVideoClose() {
            this.videoData = {};
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    mcase: this.cases.map((x) => x.uuid),
                    goods: this.goods.map((x) => x.uuid),
                    file: this.files.map((x) => ({ uuid: x.uuid, type: x.type, label: x.type == 1 ? [] : x.label })),
                    detail: this.form.type == 1 ? this.form.detail : "",
                    video_uuid: this.form.type == 2 ? this.videoData.uuid : "",
                };
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("修改成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
